import { IPersonalInfo, ConfigField } from '../../../../../types';
import { ApplicationState } from '../../../../../store';

type Fields = Pick<IPersonalInfo, 'passportNumber' | 'passportStatus' | 'passportExpiryDate' | 'passportExpectedDate'>;

type Visible = Record<'passportNumber' | 'passportStatus' | 'passportExpiryDate' | 'passportExpectedDate', boolean>;

type Mandatory = Record<'passportNumber' | 'passportStatus' | 'passportExpiryDate' | 'passportExpectedDate', boolean>;

const passportStatusLabels: { [key: string]: string } = {
  Yes: 'Yes, I have a passport',
  Applied: 'No, I have already applied for one',
  GoingToApply: 'No, I will apply for one'
};

export function passportStatusLabel(value: string | undefined) {
  return passportStatusLabels[value ?? ''] ?? '';
}

export function getPageStatus(
  config: ApplicationState['config'],
  fields: Fields
): {
  complete: boolean;
  visible: Visible;
} {
  const { passportStatus, passportNumber, passportExpectedDate, passportExpiryDate } = fields;

  const {
    PassportNumber: passportNumberConfig,
    PassportStatus: passportStatusConfig,
    PassportExpectedDate: passportExpectedDateConfig,
    PassportExpiryDate: passportExpiryDateConfig
  }: {
    [key: string]: ConfigField;
  } = config.Checklist.PersonalInfo.Page7;

  const visible: Visible = {
    passportStatus: passportStatusConfig?.visible,
    passportNumber: passportNumberConfig?.visible && passportStatus === 'Yes',
    passportExpectedDate: passportExpectedDateConfig?.visible && ['Applied', 'GoingToApply'].includes(passportStatus!),
    passportExpiryDate: passportExpiryDateConfig?.visible && passportStatus === 'Yes'
  };

  const mandatory: Mandatory = {
    passportStatus: passportStatusConfig?.mandatory,
    passportNumber: passportNumberConfig?.mandatory,
    passportExpectedDate: passportExpectedDateConfig?.mandatory,
    passportExpiryDate: passportExpiryDateConfig?.mandatory
  };

  // prettier-ignore
  const complete =
    (!visible.passportStatus || !mandatory.passportStatus || passportStatus !== '') &&
    (!visible.passportNumber || !mandatory.passportNumber || passportNumber !== '') &&
    ((passportStatus === 'Yes' && (!visible.passportExpiryDate || !mandatory.passportExpiryDate || passportExpiryDate !== '')) ||
    (['Applied', 'GoingToApply'].includes(passportStatus!) && (!visible.passportExpectedDate || !mandatory.passportExpectedDate || passportExpectedDate !== '')));

  return {
    complete,
    visible
  };
}
